'use client'
import {FolderHeart} from "lucide-react";
import {Button} from "@/shadcn/components/ui/button";
import {useRouter} from "next/navigation";
import {authClient} from "@/lib/auth-client";
import {useEffect, useState} from "react";

// Placeholder that matches real button dimensions - prevents CLS
// Wrapper-less version for use when parent provides visibility wrapper
export const FavoriteButtonPlaceholderContent = () => (
    <Button
        aria-label={'Favoriten'}
        variant={'outline'}
        size={'sm'}
        disabled
        className="flex relative items-center justify-center focus:ring-0 lg:flex-row gap-0.5 lg:gap-2 opacity-50">
        <FolderHeart className={"h-4 w-4"}/>
        <span className={"sm:text-xs lg:text-sm"}>{'Favoriten'}</span>
    </Button>
);

// Wrapped version for Suspense fallback (needs own visibility wrapper)
export const FavoriteListButtonPlaceholder = () => (
    <div className={'hidden xl:flex items-center justify-center'}>
        <FavoriteButtonPlaceholderContent/>
    </div>
);

export const FavoriteListButton = ({
                                       onClose = () => {
                                       }
                                   }: { onClose?: () => void }) => {
    const [isMounted, setIsMounted] = useState(false);
    // navigate to wunschlisten page if user is logged in, otherwise to favorites page
    const {push} = useRouter();
    const {data, isPending} = authClient.useSession();

    useEffect(() => {
        setIsMounted(true);
    }, []);

    const url = data ? '/wunschlisten' : '/favoriten';

    // Show placeholder during SSR and initial hydration to prevent CLS
    // Use wrapper-less version since parent div already has visibility wrapper
    if (!isMounted || isPending) {
        return <FavoriteButtonPlaceholderContent/>;
    }

    return <div>
        <Button
            aria-label={'Favoriten'}
            onClick={() => {
                onClose()
                push(url)
            }}
            variant={'outline'} size={'icon'}
            className={` sm:hidden  relative -mt-4 flex-col items-center justify-center focus:ring-0 lg:flex-row gap-0.5 lg:gap-2`}>
            <FolderHeart role="button" className={"h-5 w-5 "}/>

            <span className={"absolute mt-14 text-[0.65rem]"}>{'Favoriten'}</span>
        </Button>
        <Button
            aria-label={'Favoriten'}
            onClick={() => {
                onClose()
                push(url)
            }}
            size={'sm'}
            variant={'outline'}
            className={` hidden sm:flex   relative  items-center justify-center focus:ring-0 lg:flex-row gap-0.5 lg:gap-2`}>
            <FolderHeart className={"h-4 w-4 "}/>
            <span className={" sm:text-xs lg:text-sm"}>{'Favoriten'}</span>
        </Button>
    </div>

}
